// missions

export const getMissions = (state) => state?.missions?.data || [];

export const getMissionsMeta = (state) => state?.missions?.meta;

export const getMission = (state) => state?.mission;
export const getMissionTitle = (state) => state?.mission?.attributes.name;
export const getMissionId = (state) => state?.mission?.id;
export const getMissionShortId = (state) => state?.mission?.attributes.short_id;
export const getMissionType = (state) => state?.mission?.attributes.product_types[0];
// organisation
export const getMissionOrganizationName = (state) => state
.mission?.relationships.organization.attributes.name;
export const getMissionOrganizationVertical = (state) => state
.mission?.relationships.organization.attributes.vertical;
export const getMissionOrganizationLogo = (state) => state
.mission?.relationships.organization.attributes.logo;
// offer
export const getOfferTitle = (state) => state
.mission?.relationships.offers.data[0].attributes.name;
// documents
export const mission_documents = (state) => state
.mission.relationships.mission_documents.data;
export const getProductList = (state) => state
.mission?.relationships.offers.data[0].relationships.products.data;
// metas
export const getMissionMetaGroups = (state) => {
  const disabled = state.missionMetaGroupsDisabled.map(({ name }) => name);
  return state?.missionMetaGroups
  ?.filter(({ attributes }) => !disabled.includes(attributes.label))
  ?.map(
    ({ attributes, id }) => ({
      id,
      name: attributes.label,
    }),
  );
};

// state
export const getMissionEvents = (state) => state
.mission?.relationships?.events?.data;

// event
export const getMissionStates = (state) => state
.mission?.relationships?.states?.data;

export const getMissionReadOnly = (state) => [
  'ARCHIVED',
  'CANCELED',
  'COMPLETED',
  'DELIVERED',
  'UNASSIGNED',
  'IN_POST-PRODUCTION',
].includes(state?.mission?.attributes?.public_status);

export const getMissionLoading = (state) => state.missionLoading;
export const getMissionICNotReady = (state) => state.missionICNotReady;

/*
this is all Product dependant and therefor shoud not be part of those getter IMO

export const getOfferType = (state) => state?.
mission?.relationships.offers.data[0].relationships.product.data[0].
relationships.subtype.attributes.name; // can also be product_type_code depending on which info you want.

export const getExpectedMissionMediaNumber = (state) => state?.mission;
export const getMaximumMissionMediaNumber = (state) => state?.mission;
export const getUploadMissionMediaNumber = (state) => state?.mission;
export const getOfferMediaNumber = (state) => state?.mission;
export const getSendingDate = (state) => state?.mission; //created at . mission media
export const getProductName = (state) => state?.mission;
export const getExpectedProductMediaNumber = (state) => state?.mission;
export const getUploadProductMediaNumber = (state) => state?.mission;
export const getOptionalProductMediaNumber = (state) => state?.mission;
*/
